import {
  type LinePlotTemplateSettings,
  type WorkspaceLayoutTemplateSettings,
} from './workspaceTemplatesQueries';

export const DRAWER_WIDTH = 500;
export const TW_DRAWER_WIDTH = `w-[500px]`;

export const SAVE_WORKSPACE_TEMPLATE_DESCRIPTION =
  'Save your current workspace setup as a template. This will auto-apply to your personal workspace on new projects.';
export const UPDATE_WORKSPACE_TEMPLATE_DESCRIPTION =
  'Update your existing template with current workspace setup. This will auto-apply to your personal workspace on new projects.';

/**
 * The order of the fields are important and should not be alphabetized unless confirmed with design.
 * The order should match what's in settings drawer for consistency.
 *
 * Data settings:
 * - X-axis: xAxis, xLogScale, xAxisMin, xAxisMax, xAxisFormat
 * - Y-axis: yLogScale, yAxisMin, yAxisMax
 * - Smoothing: smoothingType, smoothingWeight, showOriginalAfterSmoothing
 * - Runs: maxRuns, pointVisualizationMethod, excludeOutliers
 * - Grouping: useRunsTableGroupingInPanels, groupAgg
 *
 * Display preferences:
 * - colorRunNames, displayFullRunName, showLegend, showXRange
 * - tooltipNumberOfRuns, coordinateZooming, highlightedCompanionRunOnly
 */
export const LINE_PLOT_TEMPLATE_FIELDS: (keyof LinePlotTemplateSettings)[] = [
  // X-axis settings
  'xAxis',
  'xLogScale',
  'xAxisMin',
  'xAxisMax',
  'xAxisFormat',
  // Y-axis settings
  'yLogScale',
  'yAxisMin',
  'yAxisMax',
  // Smoothing settings
  'smoothingType',
  'smoothingWeight',
  'showOriginalAfterSmoothing',
  // Runs settings
  'maxRuns',
  'pointVisualizationMethod',
  'excludeOutliers',
  // Grouping settings
  'useRunsTableGroupingInPanels',
  'groupAgg',
  // Display preferences
  'colorRunNames',
  'displayFullRunName',
  'showLegend',
  'showXRange',
  'tooltipNumberOfRuns',
  'coordinateZooming',
  'highlightedCompanionRunOnly',
];

/**
 * Workspace layout settings fields in display order.
 */
export const WORKSPACE_LAYOUT_TEMPLATE_FIELDS: (keyof WorkspaceLayoutTemplateSettings)[] =
  ['autoOrganizePrefix', 'showEmptySections', 'sortAlphabetically'];
